import React, {useEffect, useState} from "react";
import SubsectionBlock from "../../components/section-items/SubsectionBlock/SubsectionBlock";
import SubsectionTitle from "../../components/section-items/SubsectionTitle/SubsectionTitle";
import SubsectionText from "../../components/section-items/SubsectionText/SubsectionText";
import {fetchData} from "../../helpers/fetchData";
import DataTable from "../../components/tables/DataTable/DataTable";
import LoadingSpinner from "../../components/spinners/LoadingSpinner";

const Tournaments = () => {

    const [tournaments, setTournaments] = useState([]);
    const [isFetching, setIsFetching] = useState(true);

    useEffect(() => {
        fetchData('tournaments')
            .then((res) => setTournaments(res))
            .then(() => setIsFetching(false))
            .catch((e) => console.error(e))
    }, []);

    return (<SubsectionBlock id={'tournaments'} bg={'#eff2e9'}>
        <SubsectionTitle color={'#00008B'}>{'Historia rozegranych turniejów'}</SubsectionTitle>
        <SubsectionText>{'Przedstawiona tabela prezentuje listę wszystkich turniejów, w których brała udział nasza drużyna. Tabela posortowana jest według daty zakończenia turnieju.'}</SubsectionText>
        <div style={{marginTop: 30, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
            {isFetching ? <LoadingSpinner/> : <DataTable data={tournaments} dataType={'tournaments'}/>}
        </div>
    </SubsectionBlock>);
};

export default Tournaments;
